import { render, staticRenderFns } from "./DocumentDetails.vue?vue&type=template&id=366d7702&scoped=true"
import script from "./DocumentDetails.vue?vue&type=script&lang=js"
export * from "./DocumentDetails.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetails.vue?vue&type=style&index=0&id=366d7702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366d7702",
  null
  
)

export default component.exports